export const sortArrayByProperty = ( a, b, property ) => {
    if ( a[property].toLocaleLowerCase() < b[property].toLocaleLowerCase() ) { return -1; }
    if ( a[property].toLocaleLowerCase() > b[property].toLocaleLowerCase() ) { return 1; }
    return 0;
};
